import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ViewChild, signal } from '@angular/core';
import { DialogComponent } from '@src/app/shared/components/dialog/dialog.component';
import { SharedModule } from '@src/app/shared/shared.module';
import { CompanyContactsPanelComponent } from './company-contacts-panel.component';

/**
 * Invólucro de diálogo do painel de contatos, aberto pelo menu de elipses da listagem de empresas.
 *
 * Não tem lógica própria de propósito: quem sabe listar, cadastrar e excluir contato é o
 * `CompanyContactsPanelComponent`, o mesmo montado dentro do cadastro da empresa. Aqui só se
 * resolve "em que caixa isso aparece".
 */
@Component({
  selector: 'app-company-contacts-modal',
  standalone: true,
  imports: [CommonModule, SharedModule, CompanyContactsPanelComponent],
  template: `
    <app-dialog
      #dialog
      [key]="'company-contacts-modal'"
      [action]="'company-contacts'"
      [headerTheme]="'simple'"
      [title]="'Contatos da empresa'"
      [appendTo]="'body'"
      [hideDefaultFooter]="true"
      [maxWidth]="'1080px'">
      <div class="contacts-modal-body">
        <app-company-contacts-panel [companyId]="companyId()"></app-company-contacts-panel>
      </div>
    </app-dialog>
  `,
  styles: [
    `
      /* O dialogo dimensiona pelo conteudo. Sem uma largura minima, a modal com a lista vazia
         encolhia ate virar uma caixinha com o botao solto no canto. */
      .contacts-modal-body {
        width: min(76rem, 82vw);
        min-height: 12rem;
        padding: 0.25rem 0 0.5rem;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanyContactsModalComponent {
  @ViewChild('dialog') dialogRef: DialogComponent | null = null;

  readonly companyId = signal<string | null>(null);

  open(companyId: string | null | undefined): void {
    this.companyId.set(companyId ?? null);
    this.dialogRef?.open('', '', '', 'Fechar', '', 'company-contacts-modal', false, true);
  }
}
